export default "__VITE_ASSET__N2iISTu5__"